import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import STOCheckBasketPage from 'pages/sto-check/sto-check-basket/STOCheckBasket';
import { STOCheckSummaryPage } from 'pages/sto-check/sto-check-summary';

import { STO_CHECK_ROUTE_ROOT, STO_CHECK_ROUTES } from './constants';

export const useSTOCheckRouter = (): React.JSX.Element => (
  <Route
    path={STO_CHECK_ROUTE_ROOT}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.ADMIN,
          UserRolesEnum.REPLENISH,
        ]}
      />
    }
  >
    <Route
      path={STO_CHECK_ROUTES.CHECK_BASKET}
      element={<STOCheckBasketPage />}
    />
    <Route
      path={STO_CHECK_ROUTES.CHECK_SUMMARY}
      element={<STOCheckSummaryPage />}
    />
    <Route
      path={STO_CHECK_ROUTES.STO_CHECK}
      element={<Navigate to={STO_CHECK_ROUTES.CHECK_BASKET} />}
    />
  </Route>
);
